import { render, staticRenderFns } from "./DeviceActivity.vue?vue&type=template&id=2c7663bd&"
import script from "./DeviceActivity.vue?vue&type=script&lang=js&"
export * from "./DeviceActivity.vue?vue&type=script&lang=js&"
import style0 from "./DeviceActivity.vue?vue&type=style&index=0&id=2c7663bd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports